import { ExamOverviewRow } from "../../interfaces/examInterfaces";

export const EXAM_OVERVIEW_TYPES = {
  EXAM_ACCESS_UPDATED: "examAccessUpdated",
  PATHS_LOADING: "pathsLoading",
  PATHS_UPDATED: "pathsUpdated",
  SELECT_ROW: "selectedRow",
  DESELECT_ROW: "deselectRow",
  RESET_STATE: "resetState",
};

export const INITIAL_STATE = {
  examAccess: null,
  pathsLoading: true,
  paths: null,
  selectedRow: null,
};

export interface ExamState {
  examAccess: any | null;
  pathsLoading: boolean;
  paths: { [key: string]: ExamOverviewRow[] } | null; 
  selectedRow: ExamOverviewRow | null;
}

export interface Action {
  type: string;
  payload?: any;
}

const examOverviewReducer = (state = INITIAL_STATE, action: Action): ExamState => {
  switch (action.type) {
    case EXAM_OVERVIEW_TYPES.EXAM_ACCESS_UPDATED:
      return { ...state, examAccess: action.payload };

    case EXAM_OVERVIEW_TYPES.PATHS_UPDATED:
      return { ...state, paths: action.payload };

    case EXAM_OVERVIEW_TYPES.PATHS_LOADING:
      return { ...state, pathsLoading: action.payload };

    case EXAM_OVERVIEW_TYPES.SELECT_ROW:
      return {
        ...state,
        selectedRow: {
          id: action.payload.newSelected.id,
          isDirectory: action.payload.newSelected.isFolder,
          name: action.payload.newSelected.name,
          showOptions: action.payload.newSelected.showOptions,
          grade: action.payload.newSelected.grade,
        },
      };

    case EXAM_OVERVIEW_TYPES.DESELECT_ROW:
      return { ...state, selectedRow: null };

    case EXAM_OVERVIEW_TYPES.RESET_STATE:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default examOverviewReducer;
